module.exports = __webpack_public_path__ + "static/media/jorge_mendes.9f5c1cff.jpg";